(function() { 
    let tlFreeGiftOfferClone;    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if(val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val; 
                val.applyDiscounts = async (discounts) => {
                    try {
                        const cartData = await window.tlFreeGiftOffer.ajaxApi.cartGet();
                        
                        let newDiscounts = [];
                        let statusDCInCart = cartData.discount_codes.sort(
                            (a, b) => b.applicable - a.applicable
                        );;
                        const otherDiscountsInCart = [];
                        const discountsAppInCart = [];
            
                        statusDCInCart.forEach(({code}) => {
                            if(window.tlFreeGiftOffer.codeMapRuleId.get(code)){
                                discountsAppInCart.push(code)
                            }else {
                                otherDiscountsInCart.push(code)
                            }
                        })
            
                        const discountsNeedToApply = discounts.filter(discount => !discountsAppInCart.includes(discount));
                        if(discountsNeedToApply.length !== 0 ){
                            // If a discount needs to be applied to the cart but the cart already contains 5 discounts from our app, 
                            // it will not be applied and will return false.
                            newDiscounts = [...discountsNeedToApply, ...discountsAppInCart, ...otherDiscountsInCart];
                        }
            
                        if(newDiscounts.length){
                            const applyDiscount = await window.tlFreeGiftOffer.retryOnce(
                                () => window.tlFreeGiftOffer.ajaxApi.cartUpdate({ discount: newDiscounts.slice(0, 5).join(",") }), 
                                'applyDiscounts'
                            );
                            
                            
                            statusDCInCart =  applyDiscount?.discount_codes;
                            // Handle fix theme has discount box
                            window.tlFreeGiftOffer.customize.applyDiscounts(newDiscounts)
                        }
                        const appliedDC = statusDCInCart.filter((discount) => discounts.includes(discount.code) && discount.applicable)
            
                        // integrate with Discount For Gift module
                        if(window.tlDiscountCode) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:DiscountCode"));
                        }
                        
                        return appliedDC.length == discounts.length || appliedDC.length == 5;
                    } catch (error) {
                        console.log("Error when applyDiscounts: ", error)
                    }
                }  
            }
        },
        configurable: true
    });
    
})();